// extracted by mini-css-extract-plugin
export default {"main-section":"CustomPopperContent_main-section__XvI-Y","header":"CustomPopperContent_header__fSgrf","body":"CustomPopperContent_body__ybofD"};